import React from 'react';

// Shared components
import { NewFormHeading } from './FormTypography';

export const FormHeading = (props) => {
  const { part, values, children } = props;

  return (
    <NewFormHeading
      isOpen={values.partOptions.currentPart === part}
      isValid={values.partOptions.partValid[part]}
      isStarted={values.partOptions.partStarted[part]}
      children={children}
    />
  );
};
